/* eslint-disable */
// Custom GraphQL mutations for enhanced task management

export const createEnhancedTask = /* GraphQL */ `
  mutation CreateEnhancedTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      title
      description
      assignedTo
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      category
      assignedUserId
      assignedUser {
        id
        name
        email
        role
        __typename
      }
      createdBy
      creator {
        id
        name
        email
        role
        __typename
      }
      approvedBy
      approver {
        id
        name
        email
        __typename
      }
      parentTaskId
      parentTask {
        id
        title
        __typename
      }
      templateId
      template {
        id
        name
        category
        __typename
      }
      recurring
      recurrencePattern
      nextRecurrence
      tags
      customFields
      approvalRequired
      latitude
      longitude
      dependencies {
        items {
          id
          dependencyType
          dependsOnTask {
            id
            title
            status
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      timeLogs {
        items {
          id
          startTime
          endTime
          duration
          description
          user {
            id
            name
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      subtasks {
        items {
          id
          title
          status
          assignedUser {
            id
            name
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      attachments {
        items {
          id
          fileName
          fileUrl
          fileType
          uploadedBy
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createTaskDependency = /* GraphQL */ `
  mutation CreateTaskDependency(
    $input: CreateTaskDependencyInput!
    $condition: ModelTaskDependencyConditionInput
  ) {
    createTaskDependency(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        status
        __typename
      }
      dependsOnTaskId
      dependsOnTask {
        id
        title
        status
        __typename
      }
      dependencyType
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createTimeLog = /* GraphQL */ `
  mutation CreateTimeLog(
    $input: CreateTimeLogInput!
    $condition: ModelTimeLogConditionInput
  ) {
    createTimeLog(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        __typename
      }
      userId
      user {
        id
        name
        email
        __typename
      }
      startTime
      endTime
      duration
      description
      breakTime
      isAutoTracked
      location
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createTaskTemplate = /* GraphQL */ `
  mutation CreateTaskTemplate(
    $input: CreateTaskTemplateInput!
    $condition: ModelTaskTemplateConditionInput
  ) {
    createTaskTemplate(input: $input, condition: $condition) {
      id
      name
      description
      category
      estimatedHours
      priority
      assignedRole
      area
      recurrencePattern
      customFields
      instructions
      requiredSkills
      tools
      isActive
      createdBy
      creator {
        id
        name
        email
        __typename
      }
      tasks {
        items {
          id
          title
          status
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createTaskAttachment = /* GraphQL */ `
  mutation CreateTaskAttachment(
    $input: CreateTaskAttachmentInput!
    $condition: ModelTaskAttachmentConditionInput
  ) {
    createTaskAttachment(input: $input, condition: $condition) {
      id
      taskId
      task {
        id
        title
        __typename
      }
      fileName
      fileUrl
      fileType
      fileSize
      uploadedBy
      uploader {
        id
        name
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateTaskStatus = /* GraphQL */ `
  mutation UpdateTaskStatus(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      title
      status
      completedAt
      assignedUser {
        id
        name
        __typename
      }
      timeLogs {
        items {
          id
          duration
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;

export const startTimeTracking = /* GraphQL */ `
  mutation StartTimeTracking(
    $taskId: ID!
    $userId: ID!
    $startTime: AWSDateTime!
    $location: String
  ) {
    createTimeLog(input: {
      taskId: $taskId
      userId: $userId
      startTime: $startTime
      isAutoTracked: true
      location: $location
    }) {
      id
      taskId
      userId
      startTime
      isAutoTracked
      location
      task {
        id
        title
        __typename
      }
      user {
        id
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const stopTimeTracking = /* GraphQL */ `
  mutation StopTimeTracking(
    $id: ID!
    $endTime: AWSDateTime!
    $duration: Int!
    $description: String
    $breakTime: Int
  ) {
    updateTimeLog(input: {
      id: $id
      endTime: $endTime
      duration: $duration
      description: $description
      breakTime: $breakTime
    }) {
      id
      taskId
      userId
      startTime
      endTime
      duration
      description
      breakTime
      isAutoTracked
      location
      task {
        id
        title
        status
        __typename
      }
      user {
        id
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const bulkCreateTasksFromTemplate = /* GraphQL */ `
  mutation BulkCreateTasksFromTemplate(
    $templateId: ID!
    $assignedUserIds: [ID!]!
    $dueDate: AWSDate
    $customFields: AWSJSON
  ) {
    # This would need to be implemented as a custom resolver
    # For now, we'll handle this in the frontend with multiple createTask calls
  }
`;

export const approveTask = /* GraphQL */ `
  mutation ApproveTask(
    $taskId: ID!
    $approvedBy: ID!
    $notes: String
  ) {
    updateTask(input: {
      id: $taskId
      status: APPROVED
      approvedBy: $approvedBy
      notes: $notes
    }) {
      id
      title
      status
      approvedBy
      approver {
        id
        name
        email
        __typename
      }
      notes
      updatedAt
      __typename
    }
  }
`;

export const rejectTask = /* GraphQL */ `
  mutation RejectTask(
    $taskId: ID!
    $approvedBy: ID!
    $notes: String!
  ) {
    updateTask(input: {
      id: $taskId
      status: REJECTED
      approvedBy: $approvedBy
      notes: $notes
    }) {
      id
      title
      status
      approvedBy
      approver {
        id
        name
        email
        __typename
      }
      notes
      updatedAt
      __typename
    }
  }
`;